import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContentType, DialogFooterType, IconNames } from '@dotcom/crown-ui';
import { AddressBookSignInModalDialogProps } from './address-book-sign-in-modal-types';
import styles from './address-book-sign-in-modal.module.scss';

export const AddressBookSignInModal = ({
  isOpen,
  handleCloseDialog,
  handleSignInButton,
  title,
}: AddressBookSignInModalDialogProps) => {
  const { t } = useTranslation();

  const CancelButton = () => (
    <Button
      onClick={() => handleCloseDialog()}
      variant="secondary"
      className={styles['footer-button']}
      testId={'address-book-sign-in-cancel-button'}
    >
      {t('AddressBookSignInModal.AddressBookSignInModalCancelButton')}
    </Button>
  );

  const SignInButton = () => (
    <Button
      onClick={() => handleSignInButton()}
      variant="primary"
      className={styles['footer-button']}
      testId={'address-book-sign-in-action-button'}
    >
      {t('AddressBookSignInModal.AddressBookSignInModalSignInButton')}
    </Button>
  );
  return (
    <Dialog
      isOpen={isOpen}
      onClose={() => handleCloseDialog()}
      title={title}
      accentIcon={IconNames.PersonPerson}
      type={DialogContentType.FeatureModal}
      dialogClassName={styles['dialog-wrapper']}
      footerType={DialogFooterType.MultipleButtons}
      secondaryActionButton={<CancelButton />}
      actionButton={<SignInButton />}
      testId={'address-book-sign-in-modal'}
    >
      {t('AddressBookSignInModal.AddressBookSignInModalContent')}
    </Dialog>
  );
};
